import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2362c3f4&class=full-height"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2362c3f4&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2362c3f4')) {
      api.createRecord('2362c3f4', component.options)
    } else {
      api.reload('2362c3f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2362c3f4&class=full-height", function () {
      api.rerender('2362c3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/articleItem/all/index.vue"
export default component.exports